import React, { useEffect, useState, useRef } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import axios from "axios";
import { AnalyticsEvent } from "../../components/elements/analytics-event";
const Dashboard = (props) => {
  const [donorFilter, setDonorFilter] = useState([]);

  const timer = useRef(0);

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/dashboard-list/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.overlayStore.socketConnect(streamType, username, slug);

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const event = urlParams.get("event");

      // timer.current = setInterval(() => receive(), 10000);

      return () => {
        props.overlayStore.socketDisconnect();
        clearInterval(timer.current);
      };
    }
  }, []);

  const {
    donations,
    polls,
    goal,
    goalVal,
    progress,
    exactPercent,
    raised,
    raisedVal,
    milestones,
    milestoneSort,
    rewards,
    remainingVal,
    campaignID,
  } = props.overlayStore;

  document.body.classList.add("dark");

  const formatNumber = (num) => {
    let value = num;
    const res = String(num).split(".");
    if (res.length === 1 || res[1].length <= 3) {
      value = value
        .toFixed(2)
        .replace(/\.00$/, "")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    return value;
  };

  // const receive = () => {
  //   console.log("receive ran");
  //   const URL = process.env.REACT_APP_SERVICE_URI + "/getNextUp/";
  //   // console.log("AS Going to write PG:", useMinDono);
  //   axios
  //     .post(URL)
  //     .then((response) => {
  //       // client.nextup = response.data.nextup;
  //       // console.log('next up', client.nextUp)
  //       // setState((prev) => {
  //       //   return {
  //       //     ...prev,
  //       //     nextup: response.data.nextup,
  //       //   };
  //       // });
  //       setNextUp(response.data.nextup);
  //       console.log("NextUp back from PG write", response);
  //     })
  //     .catch((err) => console.log("***** write to PG error:", err));

  //   // const URL2 = process.env.REACT_APP_SERVICE_URI + "/getNextComment/";
  //   // // console.log("AS Going to write PG:", useMinDono);
  //   // axios
  //   //   .post(URL2)
  //   //   .then((response) => {
  //   //     // client.nextup = response.data.nextup;
  //   //     // console.log('next up', client.nextUp)
  //   //     setShow((prev) => {
  //   //       return {
  //   //         ...prev,
  //   //         name: response.data.donorname,
  //   //         amount: response.data.donoramt,
  //   //         message: response.data.message,
  //   //       };
  //   //     });
  //   //     console.log("NextUp back from PG write", response);
  //   //   })
  //   //   .catch((err) => console.log("***** write to PG error:", err));
  // };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const donorMin = urlParams.get("donorMin");
    const donorList = donations.slice(0, donorMin).map((donation) => {
      return {
        id: donation.id,
        name: donation.donor_name,
        // time: new Date(donation.completedAt).toLocaleString(),
        amount: formatNumber(Number(donation.amount.value)),
        amountHighlight: Number(donation.amount.value),
        comment: donation.donor_comment,
        rewardID: donation.rewardId === undefined ? 0 : donation.rewardId,
        pollID:
          donation.poll_option_id === undefined ? 0 : donation.poll_option_id,
      };
    });

    console.log(donorList);

    const rewardList = rewards.map((reward) => {
      return {
        rewardId: reward.id,
        rewardName: reward.name,
      };
    });

    const pollList = polls.map((poll) => {
      return {
        pollsID: poll.id,
        pollsName: poll.name,
        pollsOption: poll.options.map((option) => {
          return {
            optionId: option.id,
            optionName: option.name,
          };
        }),
      };
    });

    console.log(pollList);

    const pollOptionsList = pollList.reduce((optionsArray, poll) => {
      optionsArray.push(poll.pollsOption);
      return optionsArray;
    }, []);

    const optionsList = pollOptionsList.flatMap((x) => x);

    let causeList = [
      {
        causeId: 75263,
        causeName: "Red Wagon for St. Jude",
      },
      {
        causeId: 75264,
        causeName: "Art Supplies for St. Jude",
      },
      { causeId: 75269, causeName: "Family Meal Card for St. Jude" },
      { causeId: 75273, causeName: "No More Chemo Party" },
      { causeId: 75279, causeName: "2/3 Share of Chemotherapy Treatment" },
      { causeId: 77777, causeName: "New Toy for Hospital Play Areas" },
      { causeId: 77778, causeName: "Share of Bone Marrow Treatment" },
    ];

    const donorResult = donorList.map((result) => {
      const rewardItem = rewardList.find(
        (rewardName) => rewardName.rewardId === result.rewardID
      );

      const causeItem = causeList.find(
        (causeName) => causeName.causeId === result.rewardID
      );

      const optionItem = optionsList.find(
        (optionName) => optionName.optionId === result.pollID
      );

      result.rewardName = rewardItem ? rewardItem.rewardName : null;
      result.causeName = causeItem ? causeItem.causeName : null;
      result.optionName = optionItem ? optionItem.optionName : null;

      return result;
    });

    setDonorFilter(
      donorResult.filter((donation) => donation.amount >= minDonation)
    );
  }, [donations, polls]);

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const minDonation = urlParams.get("minDonation");
  const highlight = urlParams.get("highlight");

  return (
    <div className="dashboard">
      {AnalyticsEvent("english", "/", "PLAY LIVE Dashboard")}
      <section className="inner-row gutters constrain content">
        <div className="col-12">
          {campaignID === 166464 ? (
            <div className="inner-row gutters constrain content therm">
              <div className="col-2 therm_raised">
                ${formatNumber(overallraised)}
              </div>
              <div className="col-8 therm_therm">
                <div className="therm_therm__wrapper">
                  <div
                    className="therm_therm__inner"
                    style={{
                      width: `${overallprogress}%`,
                    }}
                  ></div>
                </div>
              </div>
              <div className="col-2 therm_goal">
                ${formatNumber(overallgoal)}
              </div>
            </div>
          ) : (
            <div className="inner-row gutters constrain content therm">
              <div className="col-2 therm_raised">${raisedVal}</div>
              <div className="col-8 therm_therm">
                <div className="therm_therm__wrapper">
                  <div
                    className="therm_therm__inner"
                    style={{
                      width: `${progress}%`,
                    }}
                  ></div>
                </div>
              </div>
              <div className="col-2 therm_goal">${goalVal}</div>
            </div>
          )}
        </div>

        <div className="col-12">
          <div className={campaignID === 166464 ? "donors event" : "donors"}>
            <p className="header">
              {minDonation > 0
                ? "Recent Donations over $" + minDonation
                : "Recent Donations"}
            </p>
            <ul>
              {donorFilter.map((donor) => (
                <li
                  key={donor.id}
                  className={
                    donor.amountHighlight >= highlight ? "tier5" : "normal"
                  }
                >
                  <strong>{donor.name} </strong>
                  <span className="donation-amount">${donor.amount}</span>{" "}
                  {/* <p className="timestamp">{donor.time}</p> */}
                  {donor.comment ? (
                    <p className="donors_comment">
                      <strong>Comment: </strong>
                      {donor.comment}
                    </p>
                  ) : (
                    ""
                  )}
                  {donor.rewardName ? (
                    <div>
                      {donor.rewardID === 77777 ||
                      donor.rewardID === 75263 ||
                      donor.rewardID === 75264 ||
                      donor.rewardID === 75269 ||
                      donor.rewardID === 75273 ||
                      donor.rewardID === 75279 ||
                      donor.rewardID === 77778 ? (
                        ""
                      ) : (
                        <div>
                          <p className="donors_reward">
                            <em>
                              <strong>Reward: </strong>
                              {donor.rewardName}
                            </em>
                          </p>
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {donor.causeName ? (
                    <p className="donors_reward">
                      <em>
                        <strong>Reward: </strong>
                        {donor.causeName}
                      </em>
                    </p>
                  ) : (
                    ""
                  )}
                  {donor.optionName ? (
                    <p className="donors_poll">
                      <em>
                        <strong>Poll: </strong>
                        {donor.optionName}
                      </em>
                    </p>
                  ) : (
                    ""
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default inject("overlayStore", "pollStore")(observer(Dashboard));
